import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d6u0t6n5ehaffuo433s0';

export default function SEOArticleLeadForm() {
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('sending');
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="seo-article-form" className="py-12 sm:py-24 bg-[#F9F5EF]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="bg-gradient-to-br from-[#1A2B4C] to-[#253D6B] rounded-2xl sm:rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">

            {/* LEFT — Photo + Info */}
            <div className="lg:w-[42%] flex flex-col items-center justify-center p-6 sm:p-10 lg:p-14 bg-white/5">
              {/* Photo */}
              <div className="w-40 sm:w-52 lg:w-64 rounded-2xl overflow-hidden mb-5 flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/6d30fc93fc8ed1e1c30cd9a7009679b9.png"
                  alt="Ирина Шарова-Ялынпала — Маркетолог-стратег"
                  className="w-full h-auto object-contain"
                />
              </div>

              {/* Caption */}
              <div className="text-center">
                <p className="text-white font-bold text-lg font-['Playfair_Display'] leading-snug mb-1">
                  Ирина Шарова-Ялынпала
                </p>
                <p className="text-[#C5A880] text-sm font-semibold font-['Montserrat'] mb-1">
                  Маркетолог-стратег
                </p>
                <p className="text-white/60 text-sm font-['Montserrat'] leading-relaxed mb-5">
                  Помогаю вашему контенту работать на прибыль бизнеса.
                </p>

                <div className="border-t border-white/15 pt-4">
                  <p className="text-white/80 text-sm font-['Montserrat'] leading-relaxed italic">
                    «Начните строить систему продаж, которая не зависит от рекламных ставок.»
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT — Form */}
            <div className="lg:w-[58%] p-6 sm:p-10 lg:p-14">
              <div className="mb-6 sm:mb-8">
                <div className="inline-flex items-center gap-2 bg-[#C5A880]/30 border border-[#C5A880]/50 px-4 py-2 rounded-full text-xs font-semibold text-[#FFE0A8] mb-4 font-['Montserrat']">
                  <i className="ri-mail-send-line"></i>
                  Заявка на контент-стратегию
                </div>
                <h2 className="text-xl sm:text-3xl font-['Playfair_Display'] font-bold text-white mb-3 leading-tight">
                  Заказать контент-стратегию
                </h2>
                <p className="text-xs sm:text-sm text-white/60 leading-relaxed font-['Montserrat']">
                  Расскажите о вашем бизнесе — мы подберём оптимальный пакет и покажем, как SEO-статьи принесут вам клиентов.
                </p>
              </div>

              {status === 'success' ? (
                <div className="text-center py-10">
                  <div className="w-16 h-16 bg-[#C5A880]/30 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-check-line text-[#C5A880] text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white font-['Playfair_Display'] mb-2">
                    Заявка отправлена!
                  </h3>
                  <p className="text-white/60 text-sm font-['Montserrat']">
                    Мы свяжемся с вами в течение 24 часов.
                  </p>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Ваше имя *
                      </label>
                      <input
                        type="text"
                        name="name"
                        required
                        placeholder="Иван Иванов"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors"
                      />
                    </div>
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Email *
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        placeholder="ivan@company.ru"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Телефон
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="+7 (000) 000-00-00"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors"
                      />
                    </div>
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Желаемый пакет
                      </label>
                      <select
                        name="package"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors appearance-none cursor-pointer"
                      >
                        <option value="" className="text-gray-800">Выберите пакет</option>
                        <option value="start" className="text-gray-800">«Старт» — 1–2 статьи</option>
                        <option value="growth" className="text-gray-800">«Рост» — 4 статьи</option>
                        <option value="aggressive" className="text-gray-800">«Агрессивный рост» — 8+</option>
                        <option value="strategy" className="text-gray-800">Нужна консультация</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                      О вашем бизнесе
                    </label>
                    <textarea
                      name="message"
                      rows={3}
                      maxLength={500}
                      placeholder="Расскажите о нише, продукте или услуге..."
                      className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors resize-none"
                    />
                  </div>

                  {status === 'error' && (
                    <p className="text-red-400 text-xs font-['Montserrat'] text-center">
                      Ошибка при отправке. Попробуйте ещё раз.
                    </p>
                  )}

                  <button
                    type="submit"
                    disabled={status === 'sending'}
                    className="w-full bg-[#C5A880] hover:bg-[#B39770] disabled:opacity-60 text-white py-4 rounded-xl font-semibold text-sm sm:text-base font-['Montserrat'] transition-all duration-300 hover:scale-[1.02] whitespace-nowrap cursor-pointer"
                  >
                    {status === 'sending' ? 'Отправка...' : 'Заказать контент-стратегию'}
                    {status !== 'sending' && <i className="ri-arrow-right-line ml-2"></i>}
                  </button>

                  <p className="text-white/40 text-xs text-center font-['Montserrat']">
                    Нажимая кнопку, вы соглашаетесь с политикой конфиденциальности
                  </p>
                </form>
              )}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
